// src/components/PackingLists/ListPhoto.js
import React from 'react';
import { Card, Button } from 'react-bootstrap';

/**
 * ListPhoto component displays and handles the list banner image
 * 
 * @param {Object} props - Component props
 * @param {Object} props.list - The list data object
 * @param {Function} props.handleEditPhoto - Function to handle photo editing
 * @param {boolean} props.isOwner - Whether the current user is the list owner
 * @param {Function} props.getMediumImageUrl - Function to get medium-sized image URL
 * @returns {JSX.Element} Rendered component
 */
const ListPhoto = ({ list, handleEditPhoto, isOwner, getMediumImageUrl }) => {
  return (
    <>
      {list.photo ? (
        <Card className="listing-photo-card mb-4 border-0 overflow-hidden">
          <Card.Img 
            src={getMediumImageUrl(list.photo)} 
            alt={list.name}
            className="listing-photo-image responsive-photo"
          />
        </Card>
      ) : (
        isOwner && (
          <Card 
            className="no-photo-card mb-4 bg-light border-dashed responsive-banner"
            
          >
            <Card.Body className="d-flex align-items-center justify-content-center">
              <Button 
                variant="outline-secondary" 
                onClick={handleEditPhoto}
                className="px-4 py-2"
              >
                <i className="bi bi-camera me-2"></i>
                Add Photo
              </Button>
            </Card.Body>
          </Card>
        )
      )}
    </>
  );
};

export default ListPhoto;